import { Button } from "@volca/ui/components/ui/button";
import { ErrorState } from "@volca/ui/components/ui/error-state";

export const ReferralsLoadError = ({
  onRetry,
  retrying = false,
}: {
  onRetry: () => void;
  retrying?: boolean;
}) => (
  <ErrorState
    title="Couldn't load referrals"
    description="Please try again."
    retrying={retrying}
  >
    <Button
      variant="outline"
      size="sm"
      onClick={onRetry}
      disabled={retrying}
      aria-busy={retrying || undefined}
    >
      Try again
    </Button>
  </ErrorState>
);
